<template>
  <div class="projectUserDataView-all-box">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <!-- <template slot="userName">
          <el-input v-model="formData.userName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template> -->

        <template slot="email">
          <el-input v-model="formData.email" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="mobile">
          <el-input v-model="formData.mobile" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="status">
          <el-select v-model="formData.status" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option :label="$t('queryForm.disable')" value="0" />
            <el-option :label="$t('queryForm.enable')" value="1" />
          </el-select>
        </template>
      </form-table-page>
    </card>

    <card style="margin-top: 10px">
      <div class="table-content-box">
        <table-page
          :table-data="tableData"
          :change-fun="pageChange"
          :current-page="pageNum"
          :total="total"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">
            <!-- <el-table-column
              prop="userName"
              :label="$t('formData.userName')"
              align="center"
              show-overflow-tooltip
            /> -->

            <el-table-column
              prop="email"
              :label="$t('formData.companyEmail')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="companyName"
              :label="$t('formData.companyName')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="mobile"
              :label="$t('formData.mobilePhone')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="statusName"
              :label="$t('formData.status')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              prop="rolesName"
              :label="$t('formData.roleName')"
              align="center"
              show-overflow-tooltip
            />

            <el-table-column
              class-name="tabAction table-column-action-dropdown"
              prop="tab7"
              :label="$t('formData.action')"
              align="center"
              show-overflow-tooltip
              width="130"
            >
              <template slot-scope="item">
                <el-dropdown @command="constantCustom.commonDropdownCommandHandler">
                  <span class="el-dropdown-link">
                    <!-- {{$t('formData.action')}}<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <i class="el-icon-ali-TechnicalArea"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="buttonPerCheck('view')" :command="{action:projectUserInfoView,param:[item.row]}">{{ $t('button.view') }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('assign')" :command="{action:assignBtn,param:[item.row]}">{{ $t('button.assign') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-link v-if="buttonPerCheck('view')" type="primary" :underline="false" @click="projectUserInfoView(item.row)">{{ $t('button.view') }}</el-link>
                <el-link v-if="buttonPerCheck('assign')" type="primary" :underline="false" @click="assignBtn(item.row)">{{ $t('button.assign') }}</el-link> -->
              </template>
            </el-table-column>
          </template>
        </table-page>
      </div>
    </card>

  </div>
</template>

<script>
import { projectUserAssign } from '../../api/projectManagement'

export default {
  name: 'ProjectUserDataView',
  data() {
    return {
      multipleSelection: [],
      tableData: [],

      pageNum: 1,
      total: 0,
      pageSize:10,

      queryData: {
        userName: '',
        email: '',
        mobile: '',
        status: ''
      },
      formData: {
        // userName: '',
        email: '',
        mobile: '',
        status: ''
      },
      formLabel: {
        // userName: 'queryForm.userName',
        email: 'queryForm.companyEmail',
        mobile: 'queryForm.mobilePhone',
        status: 'queryForm.status'
      }

    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getProjectUserAssign()
    }
  },
  mounted() {
    const self = this
    window.projectUserDataView = self
    self.getProjectUserAssign()
  },
  methods: {
    /**
    * 查询方法
    * @constructor
    */
    Query() {
      const self = this
      self.pageNum = 1
      self.queryData = self.formData
      self.getProjectUserAssign()
    },

    /**
    * 重置
    * @constructor
    */
    Reset() {
      const self = this
      self.pageNum = 1
      self.queryData = self.formData
      self.getProjectUserAssign()
    },

    /**
    * 监听分页
    */
    pageChange(currentPage, pageSize) {
      const self = this
      self.pageNum = currentPage
      self.pageSize = pageSize
      self.getProjectUserAssign()
    },

    /**
    * table 选中事件
    * @param val
    */
    handleSelectionChange(val) {
      this.multipleSelection = val
      //console.log('11111111', this.multipleSelection)
    },

    /**
    * 跳转授权页面
    */
    assignBtn(data) {
      this.$router.push({
        name: 'projectUserDataViewDetail',
        params: {
          id: data.userId
        }
      })
    },

    /**
    * 跳转查看页面
    */
    projectUserInfoView(data) {
      this.$router.push({
        name: 'projectUserInfoView',
        query: {
          id: data.userId
        }
      })
    },

    /**
    * 获取授权用户数据
    */
    getProjectUserAssign() {
      const self = this
      const param = { pageNum: self.pageNum, pageSize: self.pageSize, ...self.queryData }
      projectUserAssign(param).then(response => {
        if (response.code === 200) {
          self.total = response.data.total
          if (response.data.list && response.data.list.length) {
            response.data.list.forEach(item => {
              item.rolesName = []
              item.statusName = item.status === '1' ? this.$t('formData.enable') : this.$t('formData.disable')
              item.roles.forEach(role => {
                item.rolesName.push(role.name)
              })

              item.rolesName = item.rolesName.toString()
            })

            self.tableData = response.data.list
          } else {
            self.tableData = []
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
